import React from 'react'

function HorticultureManagementSystem() {
  return (
    <div>HorticultureManagementSystem</div>
  )
}

export default HorticultureManagementSystem